import { Component, ElementRef, OnInit,ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DetallePedidoDTO } from 'src/app/model/detallePedidoDTO';
import { PedidoDTO } from 'src/app/model/pedidoDTO';
import { Sucursal } from 'src/app/model/sucursal';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';
import { PedidoService } from 'src/app/services/api/pedido.service';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { SucursalService } from 'src/app/services/api/sucursal.service';
import { StockERPDTO } from 'src/app/model/stockERPDTO';
import { StockERPService } from 'src/app/services/api/stockERP.service';
import { environment } from 'src/environments/environment';
import { CambioService } from 'src/app/services/api/cambio.service';
import { DetalleCambioDTO } from 'src/app/model/detalleCambioDTO';
import { PedidoOutERP } from 'src/app/model/pedido.out.ERP';
import { PedidoOutERPService } from 'src/app/services/api/pedidoOutERP.Service';
import { PedidoErpCambiado } from 'src/app/model/pedidoErpCambiado';
import { TransaccionElectronicaDTO } from 'src/app/model/transaccionElectronicaDTO';
import { NeoLinkService } from 'src/app/services/api/neoLink.service';
import { CredencialesNeoNet } from 'src/app/model/credencialNeoNet';



declare let $: any;
@Component({
  selector: 'app-gestion-pedido-detalle',
  templateUrl: './gestion-pedido-detalle.component.html',
  styleUrls: ['./gestion-pedido-detalle.component.css']
})
export class GestionPedidoDetalleComponent implements OnInit {
@ViewChild('myModal') myModal!:ElementRef;
@ViewChild('myModal2')myModal2!: ElementRef;
@ViewChild('myModal3')myModal3!: ElementRef;
formApartado!: FormGroup;
formEnvio!: FormGroup;
formCambio!: FormGroup;
idPedidoDTO:number=0;
idEstadoDetalle:number=0;
detallePedidoDTO:DetallePedidoDTO[]=[];
detallePedidoApartarDTO:DetallePedidoDTO[]=[];
sucursal:Sucursal[]=[];
transaccionElectronicaDTO:TransaccionElectronicaDTO[]=[];
detalleCambioDTO:DetalleCambioDTO[]=[];
stockERPDTO:StockERPDTO[]=[];
pedidoOutErp:PedidoOutERP[]=[];
credencialesNeoNet:CredencialesNeoNet[]=[];
pedidoOutErp2?:PedidoOutERP;
pedidoErpCambiado?:PedidoErpCambiado;
pedidoDTO:PedidoDTO[]=[];
errorForm:String[]=["0","0"];
idProductoAnteriorDTO:number=0;
idProductoCambioDTO:number=0;
modeloMx:String="";
tallaMx:String="";
colorIdErpDTO:number=0;
indiceDTO:number=0;
idUsrDTO:number=0;
cantidadDTO:number=0;
tituloDialogo:string="";
copiar:number=0;
idSucursalDTO:number=0;
codigoERPDTO:number=0;
colorERPDTO:String="";
idCambioDTO:number=0;
tipoMedia$ : String = "/0";
urlServerUpload$ : string = `${environment.HOST}/api/media/`;
merchantUserDTO?:string="";
merchantPasswordDTO?:string="";
afiliacionNeoNetDTO?:string="";
terminalNeoNetDTO?:string="";
nombreEmpresaDTO?:string="";
direccionEmpresaDTO?:string="";
authResponseDTO?:string="";
responseDTO?:string="";
retrievalResponseDTO?:string="0";
noTarjetaDTO?:string="0";
sysTraceNo?:string ="0";
fechaPedidoDTO?:string;
horaPedidoDTO?:String;
ipPublicaDTO?:String;

granTotalDTO?:number=0;
  constructor(
    private activatedRoute : ActivatedRoute,
    private router:Router,
    private detallePedidoDTOService : PedidoDTOService,
    private stockERPService : StockERPService,
    private sucursalService : SucursalService,
    private pedidoService: PedidoService,
    private tokenStorage: TokenStorageService,
    private cambioService:CambioService,
    private pedidoOutErpService:PedidoOutERPService,
    private neoLinkService:NeoLinkService,

  ){
    activatedRoute.params.subscribe( prm => {
      console.log(`El id es: ${prm['idPedido']}`);
      this.idPedidoDTO=prm['idPedido'];

  })
  }

  ngOnInit(): void {

    this.formApartado = new FormGroup({
      'txtObservacion' : new FormControl('', Validators.required)
    });

    this.formCambio = new FormGroup({
      'txtObservacion2' : new FormControl('', Validators.required)
    });

    this.formEnvio = new FormGroup({
      'txtNumeroGuia' : new FormControl('', Validators.required)
    });

    if (this.tokenStorage.getToken()!==null) {
      let json = JSON.stringify(this.tokenStorage.getUser());
       let data=JSON.parse(json.toString());
      
      this.idUsrDTO=data.idUsuario;
        }

//this.OnGetSucursal();
this.OnGetPedidoDTOById(this.idPedidoDTO);
this.OnTransaccionElectronica(this.idPedidoDTO);
   this.OnGetDetallePedidoDTOById(this.idPedidoDTO,-1);
  
this.OnGetIPPublica();

   this.OnGetPedidoOutErpSolicitado();
this.OnGetPedidoOutErpApartado();

  }



  OnGetDetallePedidoDTOById(idPedido:number,idEstado:number){
    this.detallePedidoDTOService.getDetallePedidoById(idPedido,idEstado).subscribe(response =>{
      console.log(response)
      return this.detallePedidoDTO=response
    });
  }


  OnGetPedidoDTOById(idPedido:number){
    this.detallePedidoDTOService.getPedidoById(idPedido).subscribe(response =>{
      console.log(response)
      return this.pedidoDTO=response
    })
  }


  OnGetPedidoDTOByIndice(idPedido:number,indice:number,idProducto:number){
    this.detallePedidoDTOService.getDetallePedidoByIndice(idPedido,indice,idProducto).subscribe(response =>{
      console.log(response)
    
      for (let datosresponse of response){
       this.colorIdErpDTO=Number(datosresponse.colorIdErp)
      }
    
      return this.detallePedidoApartarDTO=response
    })
  }



OnTransaccionElectronica(_idpedido:number){
  this.pedidoService.getTransaccionElectronica(_idpedido).subscribe(response =>{
    console.log(response)
    return this.transaccionElectronicaDTO=response
  })
}


  OnGetSucursal(){
    this.sucursalService.getSucursal().subscribe(response =>{
      console.log(response)
      return this.sucursal=response
    })
  }


  OnGetDetalleCambioByIndiceDetallePedido(indiceDetallePedido:any,idPedido:any,idEstado:any){



    this.cambioService.getDetalleCambioByIndiceDetallePedido(indiceDetallePedido,idPedido).subscribe(response =>{
    // console.log(response)
      
    for (let datosresponse of response){
      this.idCambioDTO=Number(datosresponse.idCambio);
      this.idProductoCambioDTO=Number(datosresponse.idProducto);
      this.colorIdErpDTO=Number(datosresponse.colorIdErp);
    }
    
    
    return this.detalleCambioDTO=response

    })


    


  }

   OnGetCredencialNeoNet(_systemtraceno:any,_total:any,_idtransaccion:any,_idpedido:any){

   
    this.pedidoService.getCredencialNeoNet().subscribe(response =>{
  
    
   for(let data of response) {
    // this.afiliacionNeoNetDTO=data.afiliacion+"";
    // this.terminalNeoNetDTO=data.terminal +"";
    // this.merchantPasswordDTO=data.merchantpassword+"";
    // this.merchantUserDTO=data.merchantuser+"";
    // this.nombreEmpresaDTO=data.nombreEmpresa+"";
    // this.direccionEmpresaDTO=data.direccion+"";

    this.GenerarAnulacionNeoNet(_systemtraceno,_total,_idtransaccion,_idpedido,data.merchantuser,data.merchantpassword,this.ipPublicaDTO,data.terminal,data.afiliacion);

  

   }




     });
  

  }





OnAnularPago(_idtipotransaccion:any,_idpedido:any,_idestado:any,_systemtraceno:any,_total:any,_idtransaccion:any){

if (_idtipotransaccion==1 ){



if (_idestado==1 ){



this.OnGetCredencialNeoNet(_systemtraceno,_total,_idtransaccion,_idpedido);




}else{
  alert("Esta compra ya fue anulada!!!");
}



}else {

  if (_idtipotransaccion==2 ){
    alert("Esta anulación no se puede operar!!!");
  }

}


}


  OnApartar(idEstado:any,indice:any,idProducto:any,cantidad:any,modelo:any,talla:any,colorIdErp:any,codigoErp:any){

// si esta en verificacion o en cambiado
if (idEstado==1 ){

  this.idProductoAnteriorDTO=idProducto;
  this.indiceDTO=indice;
  this.cantidadDTO=cantidad;
  this.modeloMx=modelo;
  this.tallaMx=talla;
  this.colorIdErpDTO=colorIdErp;
  this.codigoERPDTO=codigoErp;
  this.OnGetStockSucursal();
  
  this.OnGetPedidoDTOByIndice(this.idPedidoDTO,this.indiceDTO,this.idProductoAnteriorDTO);
  
  
      $(this.myModal.nativeElement).modal('show'); 
  
  



}



  }

  OnGetStockSucursal(){

    this.stockERPService.getStockERP(this.codigoERPDTO).subscribe(response =>{
      console.log(response)
      return this.stockERPDTO=response
    })


  }
  
  OnGetIPPublica(){
//let ippub;

  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data =>  this.getip(data.ip)
     
    )
    .catch(error =>  this.getip("0.0.0.0"));
  
 
  // return ippub;
  }

  getip(ip:any){
    this.ipPublicaDTO=ip;
console.log(   this.ipPublicaDTO);


  }

  OnGetDatosAnulacionPago(_idtransaccion:any){
    this.pedidoService.getTransaccionElectronicaById(_idtransaccion).subscribe(response =>{
  //console.log(response);
  
      
   for(let dato of response) {
    this.authResponseDTO=(dato.authIdResponse+"");
    this.retrievalResponseDTO=(dato.retrievalRefNo+"");
    this.sysTraceNo=(dato.systemTraceno+"");
    this.noTarjetaDTO=(dato.tarjeta+"");
    this.fechaPedidoDTO=(dato.fecha)+"";
    this.horaPedidoDTO=dato.hora+"";
  
   }
  
  
  
    });
  
  }


  GenerarAnulacionNeoNet(_systemtraceno:string,_total:number,_idtransaccion:number,_idpedido:number,_merchantUserDTO:any,_merchantPasswordDTO:any,_ipPublicaDTO:any,_terminalNeo:any,_afiliacionNeo:any){

 
    
      
  
let datos=
  {
    "MessageTypeId": "0200",
    "ProcessingCode": "020000",
    "SystemsTraceNo": _systemtraceno,
    "TimeLocalTrans": "",
    "DateLocalTrans": "",
    "PosEntryMode": "012",
    "Nii": "003",
    "PosConditionCode": "00",
    "AdditionalData": "",
    "OrderInformation": "",
    "FormatId": "1",
    "Merchant": {
      "TerminalId":  _terminalNeo,
      "CardAcqId": _afiliacionNeo
    },
    "Card": {
      "Type": "",
      "PrimaryAcctNum": "",
      "DateExpiration": "",
      "Cvv2": "",
      "Track2Data": "",
      "CardTokenId": "",
      "UniqueCodeofBeneciary": ""
    },
    "Amount": {
      "AmountTrans": "",
      "AmountDiscount": "",
      "RateDiscount": "",
      "AdditionalAmounts": "",
      "TaxDetail": [
      ]
    },
    "PrivateUse60": {
      "BatchNumber": ""
    },
    "PrivateUse63": {
      "LodgingFolioNumber14": "",
      "NationalCard25": "",
      "HostReferenceData31": "",
      "TaxAmount1": ""
    },
    "TokenManagement": {
      "Type": "",
      "ActionMethod": ""
    },
    "Customer": {
      "CustomerTokenId": "",
      "FirstName": "",
      "LastName": "",
      "TaxId": "",
      "IdentificationType": "",
      "PersonalId": "",
      "Email": "",
      "PhoneNumber": ""
    },
    "BillTo": {
      "FirstName": "",
      "LastName": "",
      "Company": "",
      "AddressOne": "",
      "AddressTwo": "",
      "Locality": "",
      "AdministrativeArea": "",
      "PostalCode": "",
      "Country": "",
      "Email": "",
      "PhoneNumber": ""
    },
    "ShipTo": {
      "DefaultSt": "",
      "FirstName": "",
      "LastName": "",
      "Company": "",
      "AddressOne": "",
      "AddressTwo": "",
      "Locality": "",
      "AdministrativeArea": "",
      "PostalCode": "",
      "Country": "",
      "Email": "",
      "PhoneNumber": "",
      "ShippingAddressTokenId": ""
    },
    "PaymentInstrument": {
      "PaymentInstrumentTokenId": ""
    },
    "CustomerPaymentInstrument": {
      "CustomerPaymentInstrumentTokenId": "",
      "DefaultCpi": ""
    },
    "PayerAuthentication": {
      "Step": "",
      "UrlCommerce": "",
      "ReferenceId": ""
    
  }
      };
      
      let json = JSON.stringify(datos);
      let data=JSON.parse(json.toString());
    
     
     


        this.neoLinkService.anularNeoLink( data,_merchantUserDTO,_merchantPasswordDTO,_ipPublicaDTO).subscribe(response =>{
         console.log(response)
          
     
      let jsonstring = JSON.stringify(response);
      let dataNeo=JSON.parse(jsonstring+"");
      let responseCode;
      let authResponse;
      let retrievalReponse;
      let timeLocalTrans;
      let dateLocalTrans;
    
      Object.keys(dataNeo).forEach(key => {
    
        if (`${key}`=='ResponseCode'){
       
          responseCode=`${dataNeo[key]}`;
        }
    
        if (`${key}`=='AuthIdResponse'){
       
          authResponse=`${dataNeo[key]}`;
        }
    
        if (`${key}`=='RetrievalRefNo'){
       
          retrievalReponse=`${dataNeo[key]}`;
        }

        if (`${key}`=='TimeLocalTrans'){
       
          timeLocalTrans=`${dataNeo[key]}`;
        }

        if (`${key}`=='DateLocalTrans'){
       
          dateLocalTrans=`${dataNeo[key]}`;
        }
    
      
    });
    
    
    
    
    
    
    if (responseCode!==null && responseCode=='00'){
    
      this.OnAnulaPagoTarjeta(_idtransaccion,_idpedido,"XXXX XXXX XXXX 0000  ",_systemtraceno,authResponse,retrievalReponse,_total,timeLocalTrans,dateLocalTrans);
  
     
    }
    
    
    
       });
    
        
    
    
    
    
    }







    OnAnulaPagoTarjeta(idTransaccion:any,idPedido:any,tarjeta:any,systemtraceno:any,authresponse:any,retrievalresponse:any,total:number,timelocaltrans:any,datelocaltrans:any){
      this.pedidoService.anulaPagoTarjeta(idTransaccion,idPedido,tarjeta,systemtraceno,authresponse,retrievalresponse,total,timelocaltrans,datelocaltrans).subscribe(response =>{
    alert("Anulación de pago realizado!!!!");


    this.router.navigate(['dashboard/gestion-pedido-detalle',idPedido ])

    .then(() => {
      window.location.reload();
    });
  

      });
    }

OnContinuar(){

}

OnCambiarPedido(){

 // this.OnGetPedidoOutErpCambiado();

// this.cambioService.aplicaCambio(
//   this.idCambioDTO,
//   this.idUsrDTO,
//   this.codigoERPDTO,
//   this.idSucursalDTO,
//   this.formCambio.value['txtObservacion2'].toString().toUpperCase(),
//   this.colorERPDTO,
//   this.colorIdErpDTO,
//  ).subscribe(response =>{
//     console.log(response)
//     $(this.myModal2.nativeElement).modal('hide'); 
//     alert("Producto cambiado!!!");
//     window.location.reload();
  
//   })
}


OnRegistrarEnvio(){

 if (this.ValidarEnvio()==0) {

  this.pedidoService.enviarPedido(
    this.idPedidoDTO,
    this.idProductoAnteriorDTO,
    this.indiceDTO,
    this.idUsrDTO,
    this.formEnvio.value['txtNumeroGuia'].toString().toUpperCase(),
    this.cantidadDTO,
    this.codigoERPDTO,
    this.colorERPDTO
   ).subscribe(response =>{
      console.log(response)
      $(this.myModal3.nativeElement).modal('hide'); 
      alert("Envio registrado!!!");
      window.location.reload();
    
    })




 }




  
}


OnApartarPedido(){

if (this.ValidarApartado()==0){




  this.pedidoService.apartarPedido(
    this.idPedidoDTO,
    this.idProductoAnteriorDTO,
    this.indiceDTO,
    this.idUsrDTO,
    this.formApartado.value['txtObservacion'].toString().toUpperCase(),
    this.idSucursalDTO,
    this.cantidadDTO,
    this.codigoERPDTO,
    this.colorERPDTO,
    this.colorIdErpDTO
   ).subscribe(response =>{
      console.log(response)
 
  alert("¡Producto Apartado!");
  window.location.reload();
    
    })





}


}



OnGetPedidoOutErpCambiado(){


  this.cambioService.getPedidoOutErpCambiado(this.idPedidoDTO).subscribe(response =>{
    console.log(response)

    for (let datosresponse of response){
      this.pedidoErpCambiado = new PedidoErpCambiado();
      this.pedidoErpCambiado.pedidoId =datosresponse.pedidoId,
      this.pedidoErpCambiado.pedidoDetalleId =datosresponse.pedidoDetalleId,
      this.pedidoErpCambiado.codigoErpNuevo=datosresponse.codigoErpNuevo,
      this.pedidoErpCambiado.usuarioId=datosresponse.usuarioId,
      this.pedidoErpCambiado.observaciones=datosresponse.observaciones
    }
    
//this.OnEnviarPedidoOutErpCambiado(this.pedidoErpCambiado);

    })

}



OnGetPedidoOutErpSolicitado(){


  this.pedidoService.getPedidoOutErpSolicitado(this.idPedidoDTO).subscribe(response =>{
console.log("aqui;"+JSON.stringify(response))
    for (let datos of response){
     
     this.pedidoOutErp2 = new PedidoOutERP();
     this.pedidoOutErp2.almacenId=datos.almacenId,
     this.pedidoOutErp2.codigoErp=datos.codigoErp,
     this.pedidoOutErp2.estatus=datos.estatus,
     this.pedidoOutErp2.formaPagoId=datos.formaPagoId,
     this.pedidoOutErp2.observaciones=datos.observaciones,
     this.pedidoOutErp2.pedidoDetalleId=datos.pedidoDetalleId,
     this.pedidoOutErp2.pedidoId=datos.pedidoId,
     this.pedidoOutErp2.telefonoCliente=datos.telefonoCliente,
     this.pedidoOutErp2.usuarioId=datos.usuarioId,
     this.pedidoOutErp2.precioErp=datos.precioErp,
     this.pedidoOutErp2.porcentajeDesctoEcommerce=datos.porcentajeDesctoEcommerce,
     this.pedidoOutErp2.precioFinalEcommerce=datos.precioFinalEcommerce,
     this.pedidoOutErp2.nombreCliente=datos.nombreCliente,
     this.pedidoOutErp2.idUsuario=datos.idUsuario
     this.OnEnviarPedidoOutErp(this.pedidoOutErp2)
    }
  // console.log("Solictados... "+this.pedidoOutErp2)
   
       }
      )




}



OnFinalizarPedido(_idpedido:any,_idusr:any){
  this.pedidoService.finalizarPedido(
    _idpedido,
    _idusr
    
   ).subscribe(response =>{
      console.log(response)
      alert("Pedido Finalizado!!!");
      this.router.navigateByUrl('/dashboard/gestion-pedido');
    
    })
}

OnGetPedidoOutErpApartado(){
  this.pedidoService.getPedidoOutErpApartado(this.idPedidoDTO).subscribe(response =>{
     console.log(response)
 
 
  for (let datos of response){
   
   this.pedidoOutErp2 = new PedidoOutERP();
   this.pedidoOutErp2.almacenId=datos.almacenId,
   this.pedidoOutErp2.codigoErp=datos.codigoErp,
   this.pedidoOutErp2.estatus=datos.estatus,
   this.pedidoOutErp2.formaPagoId=datos.formaPagoId,
   this.pedidoOutErp2.observaciones=datos.observaciones,
   this.pedidoOutErp2.pedidoDetalleId=datos.pedidoDetalleId,
   this.pedidoOutErp2.pedidoId=datos.pedidoId,
   this.pedidoOutErp2.telefonoCliente=datos.telefonoCliente,
   this.pedidoOutErp2.usuarioId=datos.usuarioId,
   this.pedidoOutErp2.precioErp=datos.precioErp,
   this.pedidoOutErp2.porcentajeDesctoEcommerce=datos.porcentajeDesctoEcommerce,
   this.pedidoOutErp2.precioFinalEcommerce=datos.precioFinalEcommerce,
   this.pedidoOutErp2.nombreCliente=datos.nombreCliente,
   this.pedidoOutErp2.idUsuario=datos.idUsuario
   this.OnEnviarPedidoOutErp(this.pedidoOutErp2)
  }
 
     }
     
     )
   
   
 
 }
 


OnEnviarPedidoOutErp(pedidout?:PedidoOutERP){

// if (pedidout!==null){
//   this.pedidoOutErpService.SendPedidoOutErp(pedidout).subscribe(response =>{
//     console.log("Enviado:"+ response)
//   }
//   )
// }


 
}


OnEnviarPedidoOutErpCambiado(pedidoutcambiado?:PedidoErpCambiado){
  this.pedidoOutErpService.SendPedidoOutErpCambiado(pedidoutcambiado).subscribe(response =>{
    console.log(response)
  $(this.myModal2.nativeElement).modal('hide'); 
    alert("Producto Cambiado!!!");
        window.location.reload();

  
  })

}
 



OnAnularDetallePedido(){
  $(this.myModal2.nativeElement).modal('hide'); 
  this.pedidoService.anularDetallePedido(
    this.indiceDTO,
    this.idPedidoDTO,
    this.idEstadoDetalle,
    this.idUsrDTO
    
   ).subscribe(response =>{
      console.log(response)
      alert("Producto anulado!!!");
      window.location.reload();
    
    })

}






OnEnviado(idPedido:any,indice:any,idProducto:any,idestado:any,codigoErp:any,colorErp:any){

  this.idPedidoDTO=idPedido;
  this.indiceDTO=indice;
  this.idProductoAnteriorDTO=idProducto;
  this.idEstadoDetalle=idestado;
  this.codigoERPDTO=codigoErp;
  this.colorERPDTO=colorErp;


// si esta en modo apartado

if (  this.idEstadoDetalle==2    ){


  this.OnGetPedidoDTOByIndice(this.idPedidoDTO,this.indiceDTO,this.idProductoAnteriorDTO);

  $(this.myModal3.nativeElement).modal('show'); 

}


}


OnCambio(indice:any,idProducto:any,idpedido:any,idEstado:any,modelo:any,talla:any,colorIdErp:any,codigoErp:any){
  this.idProductoAnteriorDTO=idProducto;
  this.indiceDTO=indice;
  this.idPedidoDTO=idpedido;
  this.idEstadoDetalle=idEstado;
  this.modeloMx=modelo;
  this.tallaMx=talla;
  this.colorIdErpDTO=colorIdErp;
this.codigoERPDTO=codigoErp;

// si esta en modo apartado

if (  this.idEstadoDetalle==2 || this.idEstadoDetalle==1 ){


  this.OnGetStockSucursal();
  



  $(this.myModal2.nativeElement).modal('show'); 
  this.OnGetPedidoDTOByIndice(this.idPedidoDTO,this.indiceDTO,this.idProductoAnteriorDTO);
  
  this.OnGetDetalleCambioByIndiceDetallePedido( this.indiceDTO,this.idPedidoDTO,1);
  


}

}


ValidarApartado(){
  let rs:number=0;
  let rs1:number=0;
  let rs2:number=0;
 
  
    if (this.idSucursalDTO > 0 ){
      this.errorForm[0]="0";
      rs1= 0;
      
    }else {
      this.errorForm[0]="1";
      rs1= 1;

    }

    

       if (this.formApartado.value['txtObservacion']!==""){
      this.errorForm[1]="0";
      rs2= 0;

       }else {
        this.errorForm[1]="1";
        rs2= 1;

       }

      


rs=rs1+rs2;
  
  
  
return rs;
  }


  ValidarEnvio(){
    let rs:number=0;
    let rs1:number=0;
    
   
    
      
  
         if (this.formEnvio.value['txtNumeroGuia']!==""){
        this.errorForm[1]="0";
        rs1= 0;
  
         }else {
          this.errorForm[1]="1";
          rs1= 1;
  
         }
  
        
  
  
  rs=rs1;
    
    
    
  return rs;
    }



OnVerificarEstadoPedido(){

  this.detallePedidoDTOService.getDetallePedidoById(this.idPedidoDTO,-1).subscribe(response =>{
 //   console.log(response)
   // return this.detallePedidoDTO=response

let contador:number=0;
   for(let dato of response) {

  if (dato.idEstado==1 || dato.idEstado==2){
    contador++;
  }
   
  
   }

if (contador==0){

this.OnFinalizarPedido(this.idPedidoDTO,this.idUsrDTO);

}else {
  alert("Acción NO PERMITIDA, existen productos pendiente por  APARTAR o ENVIAR");
}


  });


}


OnConfirmarDialogo(){

  if (this.copiar==1){

this.OnAnularDetallePedido();

  }else {

    if (this.copiar==2){


    }


  }



}

OnSeleccionarStockERP(almacenid:any,codigoerp:any,colorerp:any){
this.idSucursalDTO=almacenid;
this.codigoERPDTO=codigoerp;
this.colorERPDTO=colorerp;


}



}
